import type { PaymentMethod } from '@brighterly/lib-core-types/payments/interfaces'

import { useCsRoutes } from '@shared/api'

import { usePaymentsStore } from '../model/store/store'

interface PaymentsMethodsApiOptions {
  onStart?: () => void
  onSuccess?: () => void
  onError?: (err: any) => void
  onFinish?: () => void
}
export const usePaymentsMethodsApi = async (options?: PaymentsMethodsApiOptions): Promise<PaymentMethod[]> => {
  const { $axios } = useNuxtApp()

  const paymentsStore = usePaymentsStore()

  const url = useCsRoutes('payment.methods')

  paymentsStore.setPaymentMethodsListLoading(true)
  paymentsStore.setPaymentMethodsClear()

  options?.onStart?.()

  try {
    const { data } = await $axios.get(url!)
    const methods = data?.data?.methods || []

    paymentsStore.setPaymentMethods(methods)
    paymentsStore.setPaymentMethodsListLoading(false)

    options?.onSuccess?.()

    return methods
  } catch (err: any) {
    console.error(err)

    options?.onError?.(err)
    paymentsStore.setPaymentMethodsListLoading(false)

    return []
  } finally {
    options?.onFinish?.()
  }
}
